// extracted by mini-css-extract-plugin
export default {"input":"Input_input__g7VPH","list":"Input_list__HGXlk","textarea":"Input_textarea__oq+hD","labeltextarea":"Input_labeltextarea__eUvZS"};